//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapGetters} from "vuex";
import ConfirmDialog from '@/components/ConfirmDialog'

  export default {
    name: 'App',
    components: {
      ConfirmDialog,
    },
    data() {
      return {
        showDialog: true,
        showSnackbar: false,
        message: '',
        visible: false
      }
    },
    methods: {
      ...mapActions(['loadProcesses'])
    },
    computed: {
      ...mapGetters(['isLoggedIn'])
    },
    mounted() {
      console.log("mounted "+process.env.VUE_APP_TYPE);
      if (window.$config.APP_TYPE === "eb") {
        console.log("eb");
        document.title = "EB-Kariere";
      } else {
        document.title = "Ratgeber Stuckateurhandwerk: Alles für Ihren Wohntraum";
      }
      this.loadProcesses()
    }
  }
